
import React from 'react';

const BeforeAfter: React.FC = () => {
  return null;
};

export default BeforeAfter;
